import type { PlayResult } from '@/types/api'
import { isRangePreset, type RangePreset } from './range'

export interface AnalyticsSearch {
  range?: RangePreset
  location?: string
  display?: string
}

export interface ProofOfPlaySearch extends AnalyticsSearch {
  campaign?: string
  slideshow?: string
  result?: PlayResult
  /** Highlights an export (deep link from the "export ready" notification). */
  export?: string
}

const id = (v: unknown) => (typeof v === 'string' && /^[0-9a-zA-Z]{26}$/.test(v) ? v.toLowerCase() : undefined)
const RESULTS: PlayResult[] = ['completed', 'interrupted', 'skipped', 'error']

export function validateAnalyticsSearch(s: Record<string, unknown>): AnalyticsSearch {
  return { range: isRangePreset(s.range) ? s.range : undefined, location: id(s.location), display: id(s.display) }
}

export function validateProofOfPlaySearch(s: Record<string, unknown>): ProofOfPlaySearch {
  return {
    ...validateAnalyticsSearch(s),
    campaign: id(s.campaign),
    slideshow: id(s.slideshow),
    result: RESULTS.includes(s.result as PlayResult) ? (s.result as PlayResult) : undefined,
    export: id(s.export),
  }
}
